import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnterKey = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Enter",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M1.66112 2.63416H2.8695C2.95812 2.63416 3.03062 2.70106 3.03062 2.78283V12.4098H12.8185V11.0531C12.8185 10.9286 12.9756 10.8579 13.0804 10.936L15.9382 13.0175C15.9574 13.0314 15.973 13.0492 15.9837 13.0695C15.9944 13.0897 16 13.112 16 13.1346C16 13.1571 15.9944 13.1794 15.9837 13.1997C15.973 13.22 15.9574 13.2377 15.9382 13.2517L13.0804 15.3332C12.9736 15.4112 12.8185 15.3406 12.8185 15.2161V13.8222H2.78894C2.07801 13.8222 1.5 13.2888 1.5 12.6328V2.78283C1.5 2.70106 1.5725 2.63416 1.66112 2.63416Z",
			fill: "currentColor",
			fillOpacity: .85
		})
	})]
});
const ForwardRef = forwardRef(SvgEnterKey);
export { ForwardRef as ReactComponent };
